import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AnnouncementBar } from "@/components/AnnouncementBar";

export const StoreLayout = () => (
  <div className="min-h-screen flex flex-col overflow-x-hidden">
    <AnnouncementBar />
    <Navbar />
    <main className="flex-1"><Outlet /></main>
    <Footer />
  </div>
);
